<section class="hero-section">
    @if (herosData.length) {
    <div class="hero-bg">
        <img [src]="herosData[currentIndex].image" alt="Colorful toy blocks" />
        <div class="hero-overlay gradient-2"></div>
    </div>

    <div class="hero-container container">
        <div class="hero-content">
            <div class="right-arrow-section">
                <button mat-icon-button class="backward-button icon-button-overlay-remove" (click)="prevSlide()">
                    <mat-icon [svgIcon]="'backarrow'" class="backward-icon"></mat-icon>
                </button>
            </div>

            <div class="middle-section">
                <p class="hero-subtitle-2">{{ herosData[currentIndex].subtitle2 }}</p>
                <p class="hero-title">{{ herosData[currentIndex].title }}</p>
                <p class="hero-subtitle">{{ herosData[currentIndex].subtitle }}</p>

                <div class="button-container">
                    <button mat-stroked-button class="explore-btn" (click)="navigateProductPage()">Explore Now</button>
                    <button mat-stroked-button class="start-design-btn" (click)="navigateDesigner()">
                        Start Designing
                    </button>
                </div>
            </div>

            <div class="left-arrow-section">
                <button mat-icon-button class="forward-button icon-button-overlay-remove" (click)="nextSlide()">
                    <mat-icon [svgIcon]="'forwardarrow'" class="forward-icon"></mat-icon>
                </button>
            </div>
        </div>
    </div>
    } @if (herosData.length > 1) {
    <div class="hero-dots">
        @for (hero of herosData; let i = $index; track i) {
        <span class="carousel-dot" [class.active]="i === currentIndex" (click)="goToSlide(i)"></span>
        }
    </div>
    }
</section>
